import { render, staticRenderFns } from "./AvatarSubject.vue?vue&type=template&id=c9234c62&scoped=true"
import script from "./AvatarSubject.vue?vue&type=script&lang=js"
export * from "./AvatarSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9234c62",
  null
  
)

export default component.exports